import React, { useContext, useState } from "react";
import styles from "./ChallengeModal.module.css";
import FormSection from "./FormSection";
import Modal from "../../../Reusable/Modal/Modal";
import Header from "../Header/Header";
import DateTimeModal from "../DateTimeModal/DateTimeModal";
import { MatchContext } from "../../../../createContext/Match/MatchContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ChallengeModal = (props) => {
  const {createMatch} = useContext(MatchContext);
  const [caption, setCaption] = useState("");
  const [matchName, setMatchName] = useState(""); // New state for match name
  const [matchType, setMatchType] = useState("1on1");
  const [sport, setSport] = useState("");
  const [opponent, setOpponent] = useState([]);
  const [selectedDate, setSelectedDate] = useState({
    day: new Date().getDate(), // Day of the month
    monthName: new Date().toLocaleString("default", { month: "short" }), // Short month name
    year: new Date().getFullYear(), // Year
    hours: new Date().getHours(), // Current hour
    minutes: new Date().getMinutes(), // Cuprops.oncloserrent minutes
    month: new Date().getMonth(),
  });
  const [venue, setVenue] = useState("");
  const [teamName, setTeamName] = useState("");
  const [OppTeamName, setOppTeamName] = useState("");
  const [players, setPlayers] = useState([]);
  const isDateTime=true;
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formFields1on1 = [
    {
      label: "Match Name *",
      icon: "🏆",
      inputType: "text",
      placeholder: "Championship Final",
      value: matchName,
      onChange: (e) => setMatchName(e.target.value),
    },
    {
      label: "Choose sport *",
      icon: "🏀",
      inputType: "text",
      placeholder: "Tennis",
      value: sport,
      onChange: (e) => setSport(e.target.value),
      type:"sports"
    },
    {
      label: "Choose opponent",
      icon: "👤",
      inputType: "text",
      placeholder: "john",
      value: opponent,
      onChange: (e) => setOpponent(e.target.value),
      type:"player"
    },
    {
      label: "Choose date & time *",
      icon: "🕓",
      inputType: "text",
      value: `${selectedDate.day} ${monthNames[selectedDate.month]} , ${
        selectedDate.hours % 12 === 0 ? 12 : selectedDate.hours % 12
      }:${
        selectedDate.minutes < 10 ? "0" + selectedDate.minutes : selectedDate.minutes
      } ${selectedDate.hours >= 12 ? "PM" : "AM"}`, // Convert to 12-hour format
      placeholder: "12 Sep 2:00 PM",
      onClick: () => {
        props.handleShowDateModal();
      },
      readOnly: isDateTime,
    }
    ,
    {
      label: "Choose venue *",
      icon: "📍",
      inputType: "text",
      placeholder: "AB Stadium, Downton, USA",
      value: venue,
      onChange: (e) => setVenue(e.target.value),
      setVenue: setVenue,
    },
  ];

  const leftColumnFields = [
    {
      label: "Match Name *",
      icon: "🏆",
      inputType: "text",
      placeholder: "Championship Final",
      value: matchName,
      onChange: (e) => setMatchName(e.target.value),
    },
    {
      label: "Choose sport *",
      icon: "🏀",
      inputType: "text",
      placeholder: "Tennis",
      value: sport,
      onChange: (e) => setSport(e.target.value),
      type: "sports"
    },
    {
      label: "Choose date & time *",
      icon: "🕓",
      inputType: "text",
      value: `${selectedDate.day} ${monthNames[selectedDate.month]} , ${
        selectedDate.hours % 12 === 0 ? 12 : selectedDate.hours % 12
      }:${
        selectedDate.minutes < 10 ? "0" + selectedDate.minutes : selectedDate.minutes
      } ${selectedDate.hours >= 12 ? "PM" : "AM"}`, // Convert to 12-hour format
      placeholder: "12 Sep 2:00 PM",
      onClick: () => {
        props.handleShowDateModal();
      },
      readOnly: isDateTime,
    },
    {
      label: "Choose venue *",
      icon: "📍",
      inputType: "text",
      placeholder: "AB Stadium, Downton, USA",
      value: venue,
      onChange: (e) => setVenue(e.target.value),
      setVenue: setVenue,
    },
  ];

  const rightColumnFields = [
    {
      label: "Choose team name *",
      icon: "📋",
      inputType: "text",
      placeholder: "Fisko FC",
      value: teamName,
      onChange: (e) => setTeamName(e.target.value),
    },
    {
      label: "Select Players (1st as Leader) *",
      icon: "👥",
      inputType: "text",
      placeholder: "john, batista, alex",
      value: players,
      onChange: (e) => setPlayers(e.target.value),
      type:"players"
    },
    {
      label: "Choose Opponent's team name *",
      icon: "📋",
      inputType: "text",
      placeholder: "Fisko FC",
      value: OppTeamName,
      onChange: (e) => setOppTeamName(e.target.value),
    },
    {
      label: "Select Opponent (1st as Leader)*",
      icon: "👥",
      inputType: "text",
      placeholder: "john, batista, alex",
      value: opponent,
      onChange: (e) => setOpponent(e.target.value),
      type:"players"  
    },
  ];

  const handleMatchTypeChange = (type) => {
    setMatchType(type);
  };


  const handleSubmit2 = async () => {
    try {
      // Validation: Check if fields are empty
      if (!matchName) {
        toast.error('Match name is required!');
        return;
      }
  
      if (!venue) {
        toast.error('Location is required!');
        return;
      }
  
      if (!sport || !sport._id) {
        toast.error('Sport is required!');
        return;
      }
  
      const dateObj = new Date(
        selectedDate.year,
        selectedDate.month,
        selectedDate.day,
        selectedDate.hours,
        selectedDate.minutes
      );
  
      // Convert to ISO format and epoch time
      const date = dateObj.toISOString();
  
      const matchdata = {
        name: matchName,
        date,
        agreementTime: Math.floor(dateObj.getTime() / 1000),
        location: venue,
        sport: sport._id
      };
  
      if (matchType === '1on1') {
        // For 1on1 match
        if (opponent._id !== undefined) {
          toast.success('1on1 match created successfully!'); // Success toast
          await createMatch("1on1", opponent._id, matchdata);
          resetForm(); // Reset the form after success
        } else {
          toast.error('Opponent is required!');
        }
  
      } else {
        // For team match
        const my_players = players.map(player => player._id);
        const opponent_players = opponent.map(player => player._id);
  
        if (players.length === 0) {
          toast.error('Please select at least one player for your team!');
          return; // Stop execution if no players are selected
        }
  
        if (opponent.length === 0) {
          toast.error('Please select an opponent!');
          return; // Stop execution if no opponent is selected
        }
        if (teamName === "" || OppTeamName === "") {
          toast.error('Team name is required!');
          return;
        }
  
        toast.success('Team match created successfully!'); // Success toast
        await createMatch("team", {
          team1: {
            name: teamName,
            participants: my_players
          },
          team2: {
            name: OppTeamName,
            participants: opponent_players
          }
        }, matchdata);
  
        resetForm(); // Reset the form after success
      }
    } catch (e) {
      console.log(e);
      toast.error('Error creating match! Please try again.'); // Error toast
    }
  };
  
  const resetForm = () => {
    // Reset form state
    setMatchName("");
    setSport("");
    setOpponent([]);
    setVenue("");
    setTeamName("");
    setOppTeamName("");
    setPlayers([]);
    setSelectedDate({
      day: new Date().getDate(),
      monthName: new Date().toLocaleString("default", { month: "short" }),
      year: new Date().getFullYear(),
      hours: new Date().getHours(),
      minutes: new Date().getMinutes(),
      month: new Date().getMonth(),
    });
  };
  

  return (
    <>
      {/* For 1on1 match modal */}
      {!props.showDateTimeModal && matchType === "1on1" && (
        <Modal {...props}   widthModalContent={styles.modalContentWidth}>
          <Header
            caption={caption}
            setCaption={setCaption}
            matchType={matchType}
            handleMatchTypeChange={handleMatchTypeChange}
          />
          {formFields1on1.map((field, index) => (
            <FormSection
              key={index}
              label={field.label}
              icon={field.icon}
              inputType={field.inputType}
              placeholder={field.placeholder}
              value={field.value}
              onChange={field.onChange}
              onClick={field.onClick}
              isDateTime={isDateTime}
              type={field.type}
              setVenue={field?.setVenue}
            />
          ))}
          <div className={styles.disclaimerWrapper}>
            <p className={styles.disclaimerText}>
              <strong>Fisiko is NOT liable for any wager or bets placed on the matches by anyone including players, spectators or anyone else</strong>
            </p>
          </div>
          <div className={styles.submitButtonWrapper}>
            <button className={styles.submitButton}  onClick={()=>{props.onClose();handleSubmit2()}}>Send</button>
          </div>
        </Modal>
      )}

      {/* For team match modal */}
      {!props.showDateTimeModal && matchType === "team" && (
        <Modal {...props} widthModalContent={styles.modalContentTeamWidth}>
          <Header
            caption={caption}
            setCaption={setCaption}
            matchType={matchType}
            handleMatchTypeChange={handleMatchTypeChange}
          />
          <div className={styles.formContainer}>
            <div className={styles.formColumn}>
              {leftColumnFields.map((field, index) => (
                <FormSection
                  key={index}
                  label={field.label}
                  icon={field.icon}
                  inputType={field.inputType}
                  placeholder={field.placeholder}
                  value={field.value}
                  onChange={field.onChange}
                  onClick={field.onClick}
                  type={field.type}
                  setVenue={field?.setVenue}
                />
              ))}
            </div>
            <div className={styles.formColumn}>
              {rightColumnFields.map((field, index) => (
                <FormSection
                  key={index}
                  label={field.label}
                  icon={field.icon}
                  inputType={field.inputType}
                  placeholder={field.placeholder}
                  value={field.value}
                  onChange={field.onChange}
                  type={field.type}
                />
              ))}
            </div>
          </div>
          <div className={styles.disclaimerWrapper}>
            <p className={styles.disclaimerText}>
              <strong>Fisiko is NOT liable for any wager or bets placed on the matches by anyone including players, spectators or anyone else</strong>
            </p>
          </div>
          <div className={styles.submitButtonWrapper}>
            <button className={styles.submitButton} onClick={()=>{props.onClose();handleSubmit2()}}>Send</button>
          </div>
        </Modal>
      )}

      {/* Date Modal */}
      {props.showDateTimeModal && (
        <DateTimeModal
          {...props}
          currentDate={selectedDate}
          setCurrentDate={setSelectedDate}
          isDateTime={isDateTime}
          monthNames={monthNames}
          handleShowDateModal={props.handleShowDateModal}
        />
      )}
      <ToastContainer />
    </>
  );
};

export default ChallengeModal;